import { render, staticRenderFns } from "./ProxyReceiver.vue?vue&type=template&id=ae3dbb2a&scoped=true&"
import script from "./ProxyReceiver.vue?vue&type=script&lang=js&"
export * from "./ProxyReceiver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae3dbb2a",
  null
  
)

export default component.exports